export default "__VITE_ASSET__d7330a65__"